import './ImageBlock.less';
import React from 'react';
import classNames from 'classnames';
import LazyLoad from 'lib/components/lazyload';
import { ImageEditor } from './ImageEditor';
import { updateEntity } from 'lib/helpers';

export class ImageBlock extends React.PureComponent {
	static wrapperClassName = 'image-block-wrapper';

	state = {
		loadError: null,
	}

	render() {
		if (!this.state.loaded) {
			console.trace('render image ' + this.state.loaded);
		}
		const { entityData, onRemove, checkAllowAccessOrigin } = this.props.blockProps;

		if (!entityData) {
			return <div>抱歉，图片信息已丢失，<a onClick={onRemove}>点此清理</a></div>;
		}

		const {
			placeHolderUrl,
			placeHolderText,
			placeHolderStyle,
			imageUrl,
			imageStyle,
			imageWidth,
			imageHeight,
			dpi,
		} = entityData;

		let error = entityData.error || this.state.loadError;

		const hdpi = dpi === 144;

		const blockStyle = {
			fontSize: 0,
		};

		const imgStyle = {
			display: 'block',
			opacity: (imageUrl || error) ? 1 : 0.5,
			transition: 'opacity .6s ease, border-color .2s ease',
			cursor: 'default',
			maxWidth: '100%',
			minWidth: error ? 300 : 0,
			minHeight: error ? 50 : 0,
			boxShadow: error ? '0 0 10px red' : '',
			...((imageUrl ? imageStyle : placeHolderStyle) || {})
		};

		const errorStyle = {
			display: 'block',
			fontSize: '12px',
			margin: 0,
			background: '#da0000',
			color: 'white',
			padding: '2px 5px',
		};

		// 只有自己 CDN 域名下的图片才允许编辑
		const origin = imageUrl && getOrigin(imageUrl);
		const imageAccessable = origin && checkAllowAccessOrigin(origin);

		// 从本地应用粘贴的内容可能有本地路径图片
		const isLocalFile = /^file\:\/\//.test(imageUrl);

		const ieVersion = /msie (\d+)/i.test(navigator.userAgent) ? +RegExp.$1 : 0;
		const supportEdit = typeof window === 'object' && (!ieVersion || ieVersion > 9);

		if (isLocalFile) {
			error = '本地图片无法显示';
		}

		if (!imageUrl && !placeHolderUrl) {
			error = '图片不包含有效地址';
		}

		return (
			<div
				className="image-block"
				style={blockStyle}
				onMouseDown={evt => {
					evt.preventDefault();
				}}
				onMouseMove={evt => {
					evt.preventDefault();
				}}
				onMouseUp={evt => {
					evt.preventDefault();
				}}
				>
				{ error ?
					<div className="image-error">
						{ this.state.loadError &&
							<img src={imageUrl} style={{ display: 'none' }} />
						}
						<div className="error-message">{error}</div>
					</div> :
					<div className="image-content" style={{ width: imageWidth, height: imageHeight }}>
						<img
							src={hdpi ? null : (imageUrl || placeHolderUrl)}
							srcSet={hdpi ? `${imageUrl || placeHolderUrl} 2x` : null}
							style={imgStyle}
							width={imageWidth}
							height={imageHeight}
							onLoad={imageUrl ? (evt) => {
								this.setState({ loaded: true });
								// const { width, height } = evt.currentTarget;
								// const { entityKey, store } = this.props.blockProps;
								// updateEntity({ entityKey, ...store, update: { imageWidth: width, imageHeight: height }});
							} : null}
							onError={evt => this.setState({ loadError: '图片加载失败' })}
						/>
						<div className={classNames("image-block-actions", { uploading: !this.state.loaded })}>
							<div className="shadow">
								{ !this.state.loaded &&
									<span className="uploading">
										<i className="icon-loading">
										{placeHolderUrl
											? (placeHolderText || "正在上传")
											: "正在加载"
										}
										</i>
									</span>
								}
								{ this.state.loaded && imageAccessable && supportEdit &&
									<a className="action-edit" title="编辑" onClick={this.editImage}>
										<i className="icon-edit"></i>
									</a>
								}
								<a
									className="action-delete"
									title="删除"
									onClick={(evt) => {
										// 点击事件如果冒泡会导致 atomic block 选中
										evt.stopPropagation();
										evt.preventDefault();
										onRemove();
									}}>
									<i className="icon-remove"></i>
								</a>
							</div>
						</div>
					</div>
				}
				{/* <div className="image-block-actions">
					{ imageAccessable && supportEdit && <a className="action-edit" onClick={this.editImage}>编辑图片</a> }
					<a className="action-delete" onClick={onRemove}>删除</a>
				</div> */}
			</div>
		);
	}

	// shouldComponentUpdate(nextProps) {
	// 	return true;
	// 	// console.log({ nextProps, currProps: this.props });
	// 	const shouldUpdate =  nextProps.blockProps.entityData.imageUrl !== this.props.blockProps.entityData.imageUrl;

	// 	if (shouldUpdate)
	// 	console.log({
	// 		shouldUpdate,
	// 		nextUrl: nextProps.blockProps.entityData.imageUrl,
	// 		currUrl: this.props.blockProps.entityData.imageUrl,
	// 		loaded: this.state.loaded
	// 	});
	// 	return shouldUpdate || true;
	// }

	componentWillReceiveProps(nextProps) {
		if (nextProps.blockProps.entityData.imageUrl !== this.props.blockProps.entityData.imageUrl) {
			this.setState({ loaded: false });
		}
	}

	editImage = () => {
		const { entityData, entityKey, store, imageSizeLimit, uploadImage } = this.props.blockProps;
		const { imageUrl } = entityData;
		ImageEditor.edit({
			imageUrl,
			imageSizeLimit,
			uploadImage,
			onFinish: ({ url }) => {
				updateEntity({ entityKey, ...store, update: { imageUrl: url }});
			},
			onCancel: () => {

			}
		})
	}
}

function getOrigin(urlString) {
	return /^(https?:\/\/.+?)(\/|$)/.test(urlString) ? RegExp.$1 : null;
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/imagePlugin/ImageBlock.jsx